/**
 * Represents an array of devices with their breakpoints and labels.
 * Each device object contains type, breakpoint, and label properties.
 */
export const devices = [
  {
    type: 'desktop',
    breakPoint: 9999,
    label: 'Desktop',
  },
  {
    type: 'mobile',
    breakPoint: 576,
    label: 'Mobile',
  },
];

/**
 * Generates device-specific settings based on the provided parameter options.
 *
 * @param {Object} paramOptions - The parameter options for settings.
 * @return {Object} An object containing device-specific settings.
 */
export const deviceSpecificSettings = (paramOptions) => {
  const settings = {};
  for (const device of devices) {
    settings[device.type] = {
      breakpoint: device.breakPoint,
      settings: paramOptions,
    };
  }
  return settings;
};

/**
 * Generates spacing classes for each device type based on attribute values.
 *
 * @param {Object} attributeValues - The attribute values for spacing.
 * @return {string} A string containing generated spacing classes.
 */
export const generateSpacingClasses = (attributeValues) => {
  let classNames = '';
  devices.forEach((device) => {
    const deviceType = device.type;
    classNames += ` ${attributeValues[deviceType]?.settings.margin} ${attributeValues[deviceType]?.settings.padding}`;
  });
  // Trim leading and trailing spaces
  classNames = classNames.trim();
  return classNames;
};

/**
 * Generates a dropdown item for the spacing css classes with a given prefix and item.
 *
 * @param {string} prefix - The prefix for the CSS class.
 * @param {Object} item   - The item containing value and label properties.
 * @return {Object} A dropdown item object with value and label properties.
 */
export const generateClassDropdownItem = (prefix, item) => ({
  value: `${prefix}-${item.value}`,
  label: item.label,
});
